import React from 'react';
import { Users, BookOpen, Package, Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Star className="w-5 h-5 text-slate-300 fill-slate-300" data-id="element-321" />,
    text: '+500 docentes'
  }, {
    icon: <BookOpen className="w-5 h-5 text-slate-300" data-id="element-322" />,
    text: '6 Tomos completos'
  }, {
    icon: <Package className="w-5 h-5 text-slate-300" data-id="element-323" />,
    text: '4 Bonos incluidos'
  }, {
    icon: <Star className="w-5 h-5 text-slate-300 fill-slate-300" data-id="element-324" />,
    text: '4.9/5 calificación'
  }];
  return <div className="bg-[#0c241a] border-y border-[#1a3d2c] py-6" data-id="element-325">
      <div className="container mx-auto px-4" data-id="element-326">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-327">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-medium text-slate-200" data-id="element-328">
              {stat.icon}
              <span data-id="element-329">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}